import request from '../service';
import businessRequest from '../business-service';


// 获取设备列表
export const fetchDeviceList = (params: any) => {
  return request.get(
    `manager/v1/device/page`,
    {
      params,
    },
  ).then(res => res.data);
};

// 获取设备统计
export const fetchDeviceStat = params => {
  return request.get(
    `manager/v1/device/statistics`,
    {
      params,
    }
  ).then(res => res.data);
};

// 获取搜索条件
export const fetchSearchTypeList = (): Promise<any[]> => {
  return new Promise(resolve => {
    setTimeout(() => {
      resolve([
        {
          label: '名称',
          value: 'name',
        },
        {
          label: '设备ID',
          value: 'deviceId',
        },
        {
          label: '地址',
          value: 'address',
        },
        {
          label: '型号',
          value: 'model',
        },
        {
          label: '激活码',
          value: 'code',
        },
        {
          label: '标签',
          value: 'tag',
        },
      ]);
    }, 500);
  })
};

// 编辑设备
export const updateDevice = (data: any) => {
  return request.put(
    'manager/v1/device/update',
    data,
  ).then(res => res.data);
};

// 模糊查询设备标签列表
export const fetchDeviceTagList = (name: string, projectId) => {
  return request.get(
    'manager/v1/device/tag',
    {
      params: {
        name,
        projectId,
      },
    },
  ).then(res => res.data);
};

// 模糊查询设备型号列表
export const fetchDeviceModelList = (name: string) => {
  return request.get(
    'manager/v1/device/model',
    {
      params: {
        name,
      },
    },
  ).then(res => res.data);
};

// 批量追加设备标签
export const batchAddDeviceTag = (data: any) => {
  return request.put(
    'manager/v1/device/batchTieTags',
    data,
  ).then(res => res.data);
};

// 获取项目详情
export const getProject = (params: any) => {
    return request.get(
        'manager/v1/project',
        {
            params,
        },
    );
};

// 获取激活码列表
export const getActivationKey = () => {
    return businessRequest.get(
        'manager/v1/activationKey/list',
    );
};

// 获取激活码产品列表
export const getActivationProduct = () => {
    return businessRequest.get(
        'manager/v1/activationKey/product/list',
    );
};


// 购买激活码
interface PurchaseActivationKeyType {
    productId: string;
    purchaseNum: number;
}
export const purchaseActivationKey = (params: PurchaseActivationKeyType) => {
    return businessRequest.post(
        'manager/v1/activationKey/purchase',
        '',
        {
            params,
        },
    );
};

// 激活码续费
interface RenewActivationKeyType {
    activeKey: string;
    productId: number;
}
export const renewActivationKey = (params: RenewActivationKeyType) => {
    return businessRequest.post(
        'manager/v1/activationKey/renew',
        '',
        {
            params,
        },
    );
};
// 激活设备
interface ActivateDeviceType {
    activationKey: string;
    deviceId: string;
}
export const activateDevice = (params: ActivateDeviceType) => {
    return businessRequest.put(
        'manager/v1/device/activate',
        '',
        {
            params,
        },
    );
};
